<template>
    <div class="study-SRIO-item">
        <div class="block mb-16">
            <div class="block-title">
                <div class="dot" />
                {{ $t('study.landing.title[1]') }}
            </div>
            <Item
                v-if="item"
                :data="item"
                :label="false"
            />
        </div>
    </div>
</template>

<script>
import API from '@/api';
import { mapMutations } from 'vuex';
import Item from '@/components/Item.vue';

export default {
    components: {
        Item,
    },
    data() {
        return {
            item: null,
        };
    },
    watch: {
        $route() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapMutations('mNotification', ['setAlert', 'handleError']),
        async init() {
            try {
                const res = await API.BookSori.PublicFetchResource('000000000000000000000000', {
                    headers: {
                        'Content-Language': (this.$route.path.split('/')[1] || 'zhTw') === 'en' ? 'en' : 'zhTw',
                    },
                });
                this.item = res.data;
            } catch (e) {
                this.handleError({
                    message: e || this.$t('alertMessage.getdata-fail'),
                    color: 'error',
                });
            }
        },
    },
};
</script>

<style lang="scss">

</style>
